import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WebsiteFragmentsRoutingModule } from './website-fragments-routing.module';
import { AboutUsComponent } from './about-us/about-us.component';
import { AdvisoryBoardComponent } from './advisory-board/advisory-board.component';
import { BewkComponent } from './products/bewk/bewk.component';
import { BuildComponent } from './products/build/build.component';
import { InsuranceComponent } from './products/insurance/insurance.component';
import { IntroComponent } from './products/intro/intro.component';
import { LccComponent } from './products/lcc/lcc.component';
import { RebuildComponent } from './products/rebuild/rebuild.component';
import { ServicesComponent } from './products/services/services.component';
import { MaterialModule } from '@app/material.module';
import { TranslocoModule } from '@jsverse/transloco';
import { ReferenceComponent } from './about-us/reference/reference.component';
import { TeamComponent } from './about-us/team/team.component';
import { AnimatedDigitModule } from '@app/animated/animated-digit/animated-digit.module';
import { PricesComponent } from './prices/prices.component';
import { RegisterFormComponent } from '@app/register-form/register-form.component';
import { I18nModule } from '@app/i18n';
import { LcaComponent } from '@app/website_fragments/products/lca/lca.component';
import { PfComponent } from '@app/website_fragments/products/pf/pf.component';
import { EffortplannerComponent } from '@app/website_fragments/products/effortplanner/effortplanner.component';

@NgModule({
  declarations: [
    AboutUsComponent,
    AdvisoryBoardComponent,
    BewkComponent,
    BuildComponent,
    InsuranceComponent,
    IntroComponent,
    LcaComponent,
    LccComponent,
    PfComponent,
    RebuildComponent,
    ServicesComponent,
    ReferenceComponent,
    TeamComponent,
    PricesComponent,
    EffortplannerComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TranslocoModule,
    WebsiteFragmentsRoutingModule,
    AnimatedDigitModule,
    RegisterFormComponent,
    I18nModule,
  ],
  exports: [
    AboutUsComponent,
    AdvisoryBoardComponent,
    BewkComponent,
    BuildComponent,
    InsuranceComponent,
    IntroComponent,
    LcaComponent,
    PfComponent,
    LccComponent,
    RebuildComponent,
    ServicesComponent,
    ReferenceComponent,
    TeamComponent,
    PricesComponent,
    EffortplannerComponent,
  ],
})
export class WebsiteFragmentsModule {}
